import { Text as TextV2, Tooltip } from '@digibee/beehive-ui';
import React from 'react';
import styled, { css } from 'styled-components';

import Nav from '~/components/SideNav';

interface NavProps {
  isDragging: boolean;
}

// @ts-expect-error
const NavItem = styled(Nav.Item)<NavProps>`
  ${props =>
    props.isDragging
      ? css`
          cursor: grabbing !important;
          background: ${props.theme.colors.white} !important;
        `
      : ''}
`;

const WrapperText = styled.div`
  display: flex;
  align-items: center;
`;

interface ContentProps {
  isDragging?: boolean;
  actived: boolean;
  isDraggingOver?: boolean;
  children: any;
}

const Content = styled.div<ContentProps>`
  width: 192px;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  ${props =>
    !props.isDragging
      ? css`
          &:hover {
            background: ${props.theme.colors.pri25};
          }
        `
      : ''}
  ${props =>
    props.actived
      ? css`
          background: ${props.theme.colors.pri25};
        `
      : ''};

  ${props =>
    props.isDraggingOver
      ? css`
          border: 1px solid ${props.theme.colors.yel900};
          background: ${props.theme.colors.yel200};
        `
      : ''}
`;

interface ProjectProps {
  current: string;
  id: string;
  name: string;
  fetchComponents: () => void;
  resetSearch: () => void;
  onClick: (id: string) => void;
  draggingId: string;
}

const Project: React.FC<ProjectProps> = ({
  current,
  id,
  name,
  onClick,
  draggingId
}) => (
  <NavItem
    isDragging={!!draggingId}
    key={id}
    onClick={() => onClick?.(id)}
    data-testid={`run-project-item-${name}`}
  >
    <Content actived={id === current}>
      <WrapperText>
        <Tooltip content={name} align='start'>
          <TextV2
            css={{
              paddingRight: '$1',
              paddingLeft: '$2',
              lineHeight: '$3',
              fontWeight: id === current ? '$medium' : '300',
              color: id === current ? '$pri500' : '$black',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '160px'
            }}
            variant='b3'
          >
            {name}
          </TextV2>
        </Tooltip>
      </WrapperText>
    </Content>
  </NavItem>
);

export default Project;
